import { FORM_TYPES_V2 as FT2 } from '../enums/enumFormTypeV2'

// ND-Root.BT-01-notice
export const DEFAULT_DATA_NOTICE = {
  [FT2.F4]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F5]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F6]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F7]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F8]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F9]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F10]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F11]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F12]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F13]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F14]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.F15]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F16]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F17]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F18]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F19]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.F20]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F21]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F22]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F23]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F24]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F25]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F26]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F27]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F28]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.F29]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F30]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F31]: {
    'BT-01-Notice': '32009L0081',
  },
  [FT2.F32]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.F33]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F34]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F35]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.F36]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F37]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F38]: {
    'BT-01-Notice': '32014L0024',
  },
  [FT2.F39]: {
    'BT-01-Notice': '32014L0025',
  },
  [FT2.F40]: {
    'BT-01-Notice': '32014L0023',
  },
  [FT2.E1]: {},
  [FT2.E6]: {
    'BT-01-Notice': '32009L0081',
  },
}
